/**
 * Check viewport width using modernizr
 *
 * @param {string} mediaQuery the media query
 */
window.checkViewport = function checkViewport(mediaQuery) {
    if (isMobile) {
        return false;
    } else {
        return Modernizr.mq('(' + mediaQuery + ')') ? true : false;
    }
};
